const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevarFirst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Forma-1-copy-9",
    serifId: "Forma 1 copy 9",
    transform: "matrix(1,0,0,1,-1182.5,-797.991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1207.35,813.091C1207.42,813.022 1207.52,812.988 1207.62,812.988C1207.73,812.988 1207.82,813.022 1207.89,813.091C1208.05,813.229 1208.05,813.454 1207.89,813.592L1203.1,817.991L1207.89,822.391C1208.05,822.529 1208.05,822.753 1207.89,822.891C1207.74,823.029 1207.5,823.029 1207.35,822.891L1202.28,818.241C1202.13,818.103 1202.13,817.879 1202.28,817.741L1207.35,813.091Z",
    style: {
      fill: "rgb(79,79,79)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Forma-1-copy-91",
    serifId: "Forma 1 copy 9",
    transform: "matrix(1,0,0,1,-1182.5,-797.991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1202.18,813.091C1202.26,813.022 1202.35,812.988 1202.45,812.988C1202.56,812.988 1202.65,813.022 1202.73,813.091C1202.88,813.229 1202.88,813.454 1202.73,813.592L1197.93,817.991L1202.73,822.391C1202.88,822.529 1202.88,822.753 1202.73,822.891C1202.58,823.029 1202.33,823.029 1202.18,822.891L1197.11,818.241C1196.96,818.103 1196.96,817.879 1197.11,817.741L1202.18,813.091Z",
    style: {
      fill: "rgb(79,79,79)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevarFirst);
export default __webpack_public_path__ + "static/media/prevar-first.c3ecb1a8173d2ae4aa60644f935f77e7.svg";
export { ForwardRef as ReactComponent };